import handlebars from "refractor/handlebars";
export default handlebars;